// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createListDetailButtonStyle, linkLikeButtonCss } from "@conklin/App/SharedStyles/MyAccountDetailsStyles";
import { orderDetailsButtonSetStyles } from "@conklin/Overrides/Widgets/OrderDetails/OrderDetailsButtonSet";
import IconPrint from "@conklin/XDL/Icons/IconPrint";
import IconReturn from "@conklin/XDL/Icons/IconReturn";
import { mergeWithCss } from "@conklin/XDL/Utilities";
import Mail from "@insite/mobius/Icons/Mail";
import RefreshCcw from "@insite/mobius/Icons/RefreshCcw";
import RotateCcw from "@insite/mobius/Icons/RotateCcw";
import X from "@insite/mobius/Icons/X";
import { css } from "styled-components";

orderDetailsButtonSetStyles.printButton = {
    ...mergeWithCss(createListDetailButtonStyle(IconPrint), linkLikeButtonCss),
};

orderDetailsButtonSetStyles.shareEntityButtonStyles = {
    button: {
        ...mergeWithCss(createListDetailButtonStyle(Mail), linkLikeButtonCss),
    },
};

orderDetailsButtonSetStyles.reorderButton = {
    css: css`
            width: 100%;
            margin-top: 12px;
            min-height: 28px;
        `,
};

orderDetailsButtonSetStyles.rmaButton = {
    ...mergeWithCss(createListDetailButtonStyle(IconReturn), linkLikeButtonCss),
};

orderDetailsButtonSetStyles.cancelButton = {
    ...mergeWithCss(createListDetailButtonStyle(X), linkLikeButtonCss),
};

orderDetailsButtonSetStyles.spinner = {
    size: 22,
    css: css`
        margin: 8px;
    `,
};

orderDetailsButtonSetStyles.buttonsWrapper = {
   
};

orderDetailsButtonSetStyles.buttonWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 12px;
        margin: 0;
    `,
};

orderDetailsButtonSetStyles.toasterMessage = {
    css: css`
        display: flex;
        align-items: center;
        a span {
            font-size: 15px;
        }
    `,
};

orderDetailsButtonSetStyles.firstLineWrapper = {
    css: css`
        display: flex;
        align-items: center;
        gap: 24px;
    `,
};

orderDetailsButtonSetStyles.secondLineWrapper = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
    `,
};
orderDetailsButtonSetStyles.reorderWrapper = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: center;
    `,
};